import styled from 'styled-components';

// CONSTANTS
import { WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.section`
  .page-content {
    max-width: 1440px;
    position: relative;
  }

  .reviews {
    &__photos-wrap {
      margin-bottom: 20px;

      width: 100%;
      display: flex;
      justify-content: center;
    }

    &__photos {
      width: 380px;
      margin: 0 auto;

      .swiper-slide {
        height: 60px;
        width: 60px;
        display: flex;
        align-items: center;

        img.reviews__photo {
          height: 40px;
          width: 40px;
          border-radius: 50%;
          margin: 0 auto;
          opacity: 0.5;
          transition: all 0.1s ease;
        }

        &.swiper-slide-active,
        &.swiper-slide-duplicate-active {
          img.reviews__photo {
            height: 60px;
            width: 60px;
            opacity: 1;
          }
        }
      }
    }
  }

  .swiper-carousel {
    .swiper-button-nav {
      top: 220px;
      color: ${WHITE};
      opacity: 0.2;
      font-size: 2.4rem;
      padding: 0 45px;

      ${breakpoints.down('sm')} {
        display: none;
      }
    }

    .swiper-button-prev {
      left: 20px;
    }

    .swiper-button-next {
      right: 20px;
    }

    .swiper-pagination-bullets {
      bottom: -9px;
    }

    .swiper-pagination-bullet {
      height: 8px;
      width: 8px;
      border-radius: 50%;
      background: ${WHITE};
      opacity: 0.1;

      margin: 0 5px !important;

      &.swiper-pagination-bullet-active {
        opacity: 1;
      }
    }
  }
`;

export default Container;
